import CloudTagsGenerator from '@/modules/CloudTagsGenerator/CloudTagsGenerator.js';

const initCloudTagsTypeText = () => {
  const elements = Array.from(document.querySelectorAll('[data-component="tags-type-text"]'));

  elements.forEach((element) => {
    new CloudTagsGenerator(element, {
      tagSelector: '[data-entity="result-item"]',
    });
  });
};

const initCloudTagsWithIcons = () => {
  const elements = Array.from(document.querySelectorAll('[data-component="tags-type-w-icon"]'));

  elements.forEach((element) => {
    new CloudTagsGenerator(element, {
      iconSizeScale: 2.2,
      hasIcons: true,
    });
  });
};

export { initCloudTagsTypeText, initCloudTagsWithIcons };
